export const rootRoute = '/';
export const loginRoute = '/login';
// export const profileRoute = '/profile';
export const onboardRoute = '/onboard';
export const academyOnboardRoute = '/onboard/academy';
export const companyOnboardRoute = '/onboard/company';
export const academyOnboardSuccessRoute = '/onboard/academy/success';
export const companyOnboardSuccessRoute = '/onboard/company/success';
export const atsOnboardRoute = '/onboard/ATS';
export const atsOnboardSuccessRoute = '/onboard/ATS/success';
export const dashboardRoute = '/dashboard';
export const candidatesRoute = '/candidates';
export const reportDetailsRoute = '/reports/details';
export const forgetPasswordRoute = '/forget-password';
export const resetPasswordRoute = '/password/reset';
export const changePasswordRoute = '/change-password';


// WEBPACK FOOTER //
// ./src/app/utils/routePath.js